var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "runer-silhouette-running-fast",
    xmlns: "http://www.w3.org/2000/svg",
    width: 72.715,
    height: 50,
    viewBox: "0 0 72.715 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x33_6_24_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_256",
    "data-name": "Group 256",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M144.369,97.334h22.436a1.067,1.067,0,0,0,0-2.135H144.369a1.067,1.067,0,1,0,0,2.135Z",
    transform: "translate(-121.941 -92.366)",
    fill: "#aab83e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M9.759,167.351H32.2a1.067,1.067,0,1,0,0-2.135H9.759a1.067,1.067,0,1,0,0,2.135Z",
    transform: "translate(-7.396 -151.946)",
    fill: "#aab83e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M56.258,247.121a1.068,1.068,0,0,0,1.067,1.068H79.761a1.067,1.067,0,1,0,0-2.135H57.325A1.067,1.067,0,0,0,56.258,247.121Z",
    transform: "translate(-47.872 -220.734)",
    fill: "#aab83e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M21.226,336.44H1.067a1.067,1.067,0,1,0,0,2.135H21.226a1.067,1.067,0,1,0,0-2.135Z",
    transform: "translate(0 -297.646)",
    fill: "#aab83e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M352.441,87.852a5.83,5.83,0,1,0-5.831-5.83A5.83,5.83,0,0,0,352.441,87.852Z",
    transform: "translate(-294.943 -76.191)",
    fill: "#aab83e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M199.416,135.461c-3.348,4.689-7.831,5.232-12.655,2.369-.328-.195-1.785-1-2.108-1.189-7.76-4.607-15.512-2.8-20.71,4.479-2.209,3.1,2.9,6.031,5.084,2.971,2.686-3.761,6.1-4.849,9.836-3.658-1.912,3.32-3.585,6.619-5.944,11.307s-7.57,8.431-12.577,5.5c-3.613-2.111-6.87,3.078-3.269,5.183a14.775,14.775,0,0,0,18.941-3.651,3.209,3.209,0,0,0,.456.2,37.823,37.823,0,0,1,9.059,5.363c1.335,1.1,3.628,6.7,4.989,9.508,1.652,3.413,6.987.927,5.329-2.5-1.544-3.191-4.134-9.559-6.155-11.171a50.7,50.7,0,0,0-7.438-5.062q2.709-5.247,5.666-10.359c6.31,1.933,12.307-.344,16.578-6.327C206.71,135.336,201.6,132.4,199.416,135.461Z",
    transform: "translate(-132.328 -125.479)",
    fill: "#aab83e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFast);
export default __webpack_public_path__ + "static/media/fast.9c13f9ff37eb78394a14fa6a53d705d5.svg";
export { ForwardRef as ReactComponent };